import { createComponent } from "@front/utils/alpine";

export default createComponent(()=> ({
    isTouchDevice: () => window.matchMedia("(pointer: coarse)").matches,
    openSidebar: false,

    init () {
        
    },

    isTouch (e: { preventDefault: () => void; }) {
        if (window.matchMedia("(pointer: coarse)").matches) {
            e.preventDefault();
        }
    },
}));